import React from 'react';
import { ErrorBoundary } from './';

/**
 * Higher-Order Component (HOC) that wraps a given component with an ErrorBoundary.
 * This ensures that any errors during rendering or lifecycle methods are caught,
 * displaying a fallback UI and preventing the entire application from crashing.
 *
 * @param {React.ComponentType} Component - The component to wrap.
 * @returns {React.FC} A component wrapped with error boundary functionality.
 */
const withErrorBoundary = (Component) => (props) =>
  (
    <ErrorBoundary>
      <Component {...props} />
    </ErrorBoundary>
  );

export default withErrorBoundary;
